var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._b({staticClass:"yes-no-switch"},'InputComponent',_vm.$attrs,false),[_c('ChoiceComponent',{attrs:{"values":_vm.choiceValues},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }